import React from "react";
import { withTheme } from "styled-components";
import BookSwimlane from "../../bookviews/book-swimlane";
import BridgeBook from "../../book/bridge-book";
import { withAllMatches } from "../../../../components/mediaquery/breakpoints";
import { t } from "../../../../core/translate";
import FetchingSpinner from "../../../../components/spinner/render-prop-spinner";

const RecommendedLane = ({
  swimlaneStart,
  recommendedLoading,
  recommended,
  recommendedTitleKey,
  expandSwimlane
}) => {
  return (
    <FetchingSpinner
      loading={recommendedLoading}
      component={() => {
        return (
          <BookSwimlane
            isbns={recommended.slice(swimlaneStart).map(asset => asset.vbid)}
            BookObject={BridgeBook}
            headerLabel={t(recommendedTitleKey)}
            onHeaderClick={() =>
              expandSwimlane(recommended, t(recommendedTitleKey))
            }
            count={Math.max(recommended.length - 1, 0)}
            backArrow={t("page.explorer", "Explore")}
          />
        );
      }}
    />
  );
};
export default withAllMatches(withTheme(RecommendedLane));
